<script setup lang="ts">
/** The aperture mark. Fills with currentColor so it takes the tone of its context. */
</script>

<template>
  <svg class="brand-mark" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">
    <path
      d="M 134.5,50 L 134.5,24.203 A 104,104 0 0 1 221.141,174.269 L 198.8,161.371 L 195.55,167 L 128,50 Z"
    />
    <path
      d="M 192.3,172.629 L 214.641,185.528 A 104,104 0 0 1 41.359,185.528 L 63.7,172.629 L 60.45,167 L 195.55,167 Z"
    />
    <path
      d="M 57.2,161.371 L 34.859,174.269 A 104,104 0 0 1 121.5,24.203 L 121.5,50 L 128,50 L 60.45,167 Z"
    />
  </svg>
</template>
